export default __webpack_public_path__ + "static/media/featureBg.dd40e3db.png";